/* v6-search-dropdown.js — Brief #85.11
   Inline search with live Predictive Search dropdown.
   Handles all [data-v6-inline-search-wrap] inputs (header + hero variants). */
(function () {
  'use strict';

  var DEBOUNCE_MS = 200;
  var MIN_CHARS   = 2;
  var MAX_RESULTS = 5;

  function debounce(fn, ms) {
    var t;
    return function () {
      var a = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, a); }, ms);
    };
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function formatPrice(price) {
    if (price == null || price === '') return '';
    var n = parseFloat(price);
    if (isNaN(n)) return '';
    return '$' + n.toFixed(2);
  }

  function initWrap(wrap) {
    var form     = wrap.querySelector('[data-v6-inline-search-form]') || wrap.querySelector('form');
    var input    = wrap.querySelector('[data-v6-inline-search-input]');
    var dropdown = wrap.querySelector('[data-v6-inline-search-dropdown]');
    if (!input || !dropdown) return;

    var catHandle = (form && form.dataset.cat) || input.dataset.v6Cat || '';

    function buildUrl(q) {
      return '/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product'
        + '&resources[limit]=' + MAX_RESULTS
        + (catHandle ? '&resources[options][fields]=title,product_type,tag,vendor' : '');
    }

    function render(data) {
      var results  = (data && data.resources && data.resources.results) || {};
      var products = results.products || [];
      var q        = input.value.trim();

      if (products.length === 0) {
        dropdown.innerHTML = '<div class="v6-isd__empty">No results for “' + esc(q) + '”</div>';
        dropdown.hidden = false;
        return;
      }

      var html = '<ul class="v6-isd__list">';
      products.forEach(function (p) {
        var imgStyle = '';
        if (p.featured_image && p.featured_image.url) {
          imgStyle = 'background-image:url(' + esc(p.featured_image.url) + ');';
        }
        var price = formatPrice(p.price);
        html += '<li class="v6-isd__item">'
          + '<a href="' + esc(p.url) + '">'
          + '<span class="v6-isd__thumb" style="' + imgStyle + '"></span>'
          + '<span class="v6-isd__meta">'
          + '<span class="v6-isd__title">' + esc(p.title) + '</span>'
          + (price ? '<span class="v6-isd__price">' + esc(price) + '</span>' : '')
          + '</span>'
          + '</a></li>';
      });
      html += '</ul>';

      var href = '/search?q=' + encodeURIComponent(q);
      if (catHandle) href += '&cat=' + encodeURIComponent(catHandle);
      html += '<a class="v6-isd__viewall" href="' + esc(href) + '">See all results for “' + esc(q) + '” →</a>';

      dropdown.innerHTML = html;
      dropdown.hidden = false;
    }

    function hide() {
      dropdown.hidden = true;
      dropdown.innerHTML = '';
    }

    var doSearch = debounce(function (q) {
      if (q.length < MIN_CHARS) { hide(); return; }
      fetch(buildUrl(q))
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(hide);
    }, DEBOUNCE_MS);

    input.addEventListener('input', function () {
      doSearch(input.value.trim());
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { hide(); input.blur(); }
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) hide();
    });
  }

  function init() {
    document.querySelectorAll('[data-v6-inline-search-wrap]').forEach(initWrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
